import { render, staticRenderFns } from "./creatCustomer.vue?vue&type=template&id=59e1a2a8&scoped=true"
import script from "./creatCustomer.vue?vue&type=script&lang=js"
export * from "./creatCustomer.vue?vue&type=script&lang=js"
import style0 from "./creatCustomer.vue?vue&type=style&index=0&id=59e1a2a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e1a2a8",
  null
  
)

export default component.exports